import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import * as S from './styled'

const Logo = () => {
  const { logo } = useStaticQuery(
    graphql`
      query {
        logo: allWordpressAcfBrandTheme {
          edges {
            node {
              acf {
                logo {
                  localFile {
                    url
                  }
                  title
                  source_url
                  slug
                }
              }
            }
          }
        }
      }
    `
  )

  const logoUrl = logo.edges[0]?.node.acf.logo.source_url
  const awsAssetsBucket = process.env.GATSBY_AWS_BUCKET;
  const defaultLogo = `${awsAssetsBucket}/logos/header/svg/default.svg`
  return (
    <S.ContainerLogo
      id='ContainerLogo-div'
      className='ContainerLogo-div'
      data-testid='containerlogo-div'
    >
      <a
        href='/'
        id='LinkLogo-a'
        className='LinkLogo-a'
        data-testid='linklogo-a'
      >
        <S.ImgLogo
          id='ImgLogo-img'
          className='ImgLogo-img'
          data-testid='imglogo-img'
          src={logoUrl}
          alt='Home'
          onError={e => { e.currentTarget.src = defaultLogo }}
        />
      </a>
    </S.ContainerLogo>
  )
}

export default Logo
